
export function editPaneWidthHeight(pane, orientation, paneName) {
  let className = ''

  if (!pane) {
    return
  }

  const eleStyle = window.getComputedStyle(pane)

  if (orientation === 'vertical') {
    const str = eleStyle.width
    const myWidth = str.indexOf('.') === -1 ? str.split('px')[0] : str.split('.')[0]

    // console.log(orientation, ' ', paneName, ' width = ', myWidth)
    // -xs<100px .-sm<400px .-md<800px .-lg<1200px .-xl<1600px
    if (myWidth < 576){
      className = '-xs'
    } else if (myWidth < 768){
      className = '-sm'
    } else if (myWidth < 992){
      className = '-md'
    } else if (myWidth < 1200){
      className = '-lg'
    } else if (myWidth < 1600){
      className = '-xl'
    } else {
      className = '-xxl'
    }
    pane.classList.remove('-xs', '-sm', '-md', '-lg', '-xl', '-xxl')
    pane.classList.add(className)

    // if (!pane) {
    //   return
    // }
    if (myWidth < 250) {
      pane.classList.add('-minimized')
    } else {
      pane.classList.remove('-minimized')
    }
  }
  else {
    const str = eleStyle.height
    const myHeight = str.indexOf('.') === -1 ? str.split('px')[0] : str.split('.')[0]

    // console.log(orientation, ' ', paneName, ' height = ', myHeight)
    if (myHeight < 100){
      className = '-xs'
    } else if (myHeight < 400){
      className = '-sm'
    } else if (myHeight < 800){
      className = '-md'
    } else if (myHeight < 1200){
      className = '-lg'
    } else {
      className = '-xl'
    }
    pane.classList.remove('-xs', '-sm', '-md', '-lg', '-xl')
    pane.classList.add(className)

    // if (!pane) {
    //   return
    // }
    if (myHeight < 250) {
      pane.classList.add('-minimized')
    } else {
      pane.classList.remove('-minimized')
    }
  }
}
